export default __webpack_public_path__ + "static/media/icon_logout.49e19409.svg";